import * as React from 'react';
import FormCheckbox from 'cl-form/FormCheckbox';
import EbayAccountSelect from '../DialogComponents/EbayAccountSelect';
import {EbayListing} from 'cl-api';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import EbayListingsActions from '../../../ActionsManager/EbayListingsActions/EbayListingsActions';
import {
  getEbayListingsIds,
  getEbayListingsSellerId,
} from '../../../ActionsManager/EbayListingsActions/EbayListingsActionsHelpers';
import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';

interface DuplicateListingsFormData {
  copyImages: boolean;
  copyDescription: boolean;
  destinationSellerId: string;
}

export type DuplicateListingsDialogProps = SpecificFormDialogProps<
  DuplicateListingsFormData,
  {ebayListings: EbayListing[]}
>;

export default class DuplicateListingsDialog extends React.PureComponent<DuplicateListingsDialogProps> {
  render() {
    const {ebayListings, ...props} = this.props;
    return (
      <FormDialog<DuplicateListingsFormData>
        formName={EBAY_LISTINGS_ACTIONS_TYPES.DUPLICATE_LISTINGS}
        initialValues={{
          copyImages: true,
          copyDescription: true,
          destinationSellerId: getEbayListingsSellerId(ebayListings),
        }}
        title="Duplicate Listings"
        text={
          <React.Fragment>
            Drafts, similar to these listings, will be created. You’ll be able to edit them before publishing.
          </React.Fragment>
        }
        fields={[
          {
            component: EbayAccountSelect,
            name: 'destinationSellerId',
            label: 'eBay account',
            instructionText: 'Create a draft in account:',
          },
          {component: FormCheckbox, name: 'copyImages', label: 'Copy existing images'},
          {component: FormCheckbox, name: 'copyDescription', label: 'Copy existing description'},
        ]}
        actions={
          <EbayListingsActions
            types={[
              EBAY_LISTINGS_ACTIONS_TYPES.DUPLICATE_LISTINGS,
              EBAY_LISTINGS_ACTIONS_TYPES.DUPLICATE_LISTING_AND_EDIT,
            ]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
            listingsIds={getEbayListingsIds(ebayListings)}
            lastActionColor="primary"
          />
        }
        {...props}
      />
    );
  }
}
